<script lang="ts">
  import RequiresRetailerUserAuthentication from "@retailer/svelte/Cart/Page/DistributorSection/RequiresRetailerUserAuthentication.svelte";
  import { loginEvent } from "@shared/services/retailer_user_authentication_service";
  import { VT_802_SPIRITS_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";

  export let authStatus: string;
  export let authService: any;
  export let highlightErrors: boolean = false;
</script>

<div data-testid="vermont-cart-cta">
  <RequiresRetailerUserAuthentication {authStatus} {highlightErrors}>
    <div slot="invalid-description">
      <span class="fizz-text-strong">We can’t verify your myVermont DLL account.</span>
      If there are issues, please call the Vermont Department of Liquor and Lottery at
      <a href="tel:+18028282345">802-828-2345</a>.
    </div>

    <div slot="invalid-buttons">
      <a
        href={authService.loginUrl()}
        target="_blank"
        rel="noreferrer"
        class="fizz-button fizz-button-small"
        on:click={() => {
          loginEvent(authStatus, VT_802_SPIRITS_DISTRIBUTOR_ID);
          authService.refresh();
        }}
        data-testid="reconnect-account-button">Verify Account</a
      >
    </div>

    <div slot="pending-title"> Access High Proof Spirits & Liquor! </div>

    <div slot="pending-description">
      Use your myVermont DLL Account to access products from Vermont!
    </div>

    <div slot="pending-buttons">
      <button
        on:click|preventDefault={() => authService?.startVerification?.("pending")}
        class="fizz-button fizz-button-small fizz-nowrap fizz-text-strong">Verify Account</button
      >
    </div>
  </RequiresRetailerUserAuthentication>
</div>
